/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonthlyRevenue
 */
export interface MonthlyRevenue {
    /**
     * 
     * @type {string}
     * @memberof MonthlyRevenue
     */
    month: string;
    /**
     * 
     * @type {string}
     * @memberof MonthlyRevenue
     */
    label: string;
    /**
     * 
     * @type {number}
     * @memberof MonthlyRevenue
     */
    claimCount: number;
    /**
     * 
     * @type {number}
     * @memberof MonthlyRevenue
     */
    expectedFlatCents: number;
    /**
     * 
     * @type {number}
     * @memberof MonthlyRevenue
     */
    expectedPercentageCents: number;
    /**
     * 
     * @type {number}
     * @memberof MonthlyRevenue
     */
    expectedTotalCents: number;
    /**
     * 
     * @type {number}
     * @memberof MonthlyRevenue
     */
    actualFlatCents: number;
    /**
     * 
     * @type {number}
     * @memberof MonthlyRevenue
     */
    actualPercentageCents: number;
    /**
     * 
     * @type {number}
     * @memberof MonthlyRevenue
     */
    actualTotalCents: number;
    /**
     * 
     * @type {number}
     * @memberof MonthlyRevenue
     */
    outstandingFlatCents: number;
    /**
     * 
     * @type {number}
     * @memberof MonthlyRevenue
     */
    outstandingPercentageCents: number;
    /**
     * 
     * @type {number}
     * @memberof MonthlyRevenue
     */
    outstandingTotalCents: number;
}

/**
 * Check if a given object implements the MonthlyRevenue interface.
 */
export function instanceOfMonthlyRevenue(value: object): value is MonthlyRevenue {
    if (!('month' in value) || value['month'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('claimCount' in value) || value['claimCount'] === undefined) return false;
    if (!('expectedFlatCents' in value) || value['expectedFlatCents'] === undefined) return false;
    if (!('expectedPercentageCents' in value) || value['expectedPercentageCents'] === undefined) return false;
    if (!('expectedTotalCents' in value) || value['expectedTotalCents'] === undefined) return false;
    if (!('actualFlatCents' in value) || value['actualFlatCents'] === undefined) return false;
    if (!('actualPercentageCents' in value) || value['actualPercentageCents'] === undefined) return false;
    if (!('actualTotalCents' in value) || value['actualTotalCents'] === undefined) return false;
    if (!('outstandingFlatCents' in value) || value['outstandingFlatCents'] === undefined) return false;
    if (!('outstandingPercentageCents' in value) || value['outstandingPercentageCents'] === undefined) return false;
    if (!('outstandingTotalCents' in value) || value['outstandingTotalCents'] === undefined) return false;
    return true;
}

export function MonthlyRevenueFromJSON(json: any): MonthlyRevenue {
    return MonthlyRevenueFromJSONTyped(json, false);
}

export function MonthlyRevenueFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonthlyRevenue {
    if (json == null) {
        return json;
    }
    return {
        
        'month': json['month'],
        'label': json['label'],
        'claimCount': json['claimCount'],
        'expectedFlatCents': json['expectedFlatCents'],
        'expectedPercentageCents': json['expectedPercentageCents'],
        'expectedTotalCents': json['expectedTotalCents'],
        'actualFlatCents': json['actualFlatCents'],
        'actualPercentageCents': json['actualPercentageCents'],
        'actualTotalCents': json['actualTotalCents'],
        'outstandingFlatCents': json['outstandingFlatCents'],
        'outstandingPercentageCents': json['outstandingPercentageCents'],
        'outstandingTotalCents': json['outstandingTotalCents'],
    };
}

export function MonthlyRevenueToJSON(json: any): MonthlyRevenue {
    return MonthlyRevenueToJSONTyped(json, false);
}

export function MonthlyRevenueToJSONTyped(value?: MonthlyRevenue | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'month': value['month'],
        'label': value['label'],
        'claimCount': value['claimCount'],
        'expectedFlatCents': value['expectedFlatCents'],
        'expectedPercentageCents': value['expectedPercentageCents'],
        'expectedTotalCents': value['expectedTotalCents'],
        'actualFlatCents': value['actualFlatCents'],
        'actualPercentageCents': value['actualPercentageCents'],
        'actualTotalCents': value['actualTotalCents'],
        'outstandingFlatCents': value['outstandingFlatCents'],
        'outstandingPercentageCents': value['outstandingPercentageCents'],
        'outstandingTotalCents': value['outstandingTotalCents'],
    };
}

